import { Calendar, ArrowRight, Tag } from 'lucide-react';
import { Link } from 'react-router-dom';
import { blogPosts } from '@/data/siteData';
import { sortBlogPostsByDate, formatBlogCategory } from '@/lib/blogFilters';

const formatDate = (date: string) => new Date(date).toLocaleDateString('id-ID', {
  year: 'numeric', month: 'short', day: 'numeric',
});

const Notes = () => (
  <section id="notes" className="section-padding section-atmosphere bg-muted/10 border-t border-border">
    <div className="container-site">
      <div className="section-title mb-8 text-center">
        <span className="chip mb-4">Notes</span>
        <h2 className="font-display text-3xl font-light uppercase tracking-[0.03em] text-foreground sm:text-4xl">Mini Blog</h2>
        <p className="mx-auto mt-4 max-w-xl text-xs uppercase leading-relaxed tracking-wide text-muted-foreground">Catatan dan insight dari eksperimen automation, AI, dan security gue.</p>
      </div>
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {sortBlogPostsByDate(blogPosts).slice(0, 6).map((post) => (
          <Link key={post.id} to={`/blog/${post.id}`} className="group motion-panel flex min-h-56 flex-col border border-border bg-card p-6 transition-colors hover:bg-muted/50">
            <div className="flex items-center gap-2 text-[10px] font-bold uppercase text-muted-foreground"><span className="inline-flex items-center gap-1"><Tag className="h-3 w-3" /> {formatBlogCategory(post.tag)}</span><span>•</span><span className="inline-flex items-center gap-1"><Calendar className="h-3 w-3" /> {formatDate(post.date)}</span></div>
            <h3 className="mt-5 font-sans text-sm font-bold uppercase tracking-wider group-hover:underline group-hover:underline-offset-4">{post.title}</h3>
            <p className="mt-3 line-clamp-3 text-xs leading-relaxed text-muted-foreground">{post.snippet}</p>
            <span className="mt-auto inline-flex items-center gap-2 pt-6 text-[10px] font-bold uppercase tracking-wider">Baca <ArrowRight className="h-3 w-3 transition-transform group-hover:translate-x-1" /></span>
          </Link>
        ))}
      </div>
      <div className="mt-8 text-center"><Link to="/blog" className="inline-flex items-center gap-2 border border-border bg-foreground px-5 py-3 text-[10px] font-bold uppercase tracking-wider text-background hover:bg-background hover:text-foreground">Lihat semua notes <ArrowRight className="h-3 w-3" /></Link></div>
    </div>
  </section>
);

export default Notes;
